import React, { useEffect, useState } from "react";

const CommonSelect = ({ 
  label, 
  name, 
  options = [], 
  required = false,
  value,
  onChange,
  register = () => ({}), 
  getValues,
}) => {
const disableVal = options.map((opt) => opt?.name);
  const registration = register(name);
  const isDisabled = !!getValues || !disableVal[0];
  const [selectedValue, setSelectedValue] = useState(value || "");
  
   useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);

    return (
      <div className="form-group">
        <label className="form-label">
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
        
        <div className="text-input nominee-input">
          <select
            name={name}
            className="report-custom-select brokerage-select "
            {...registration}
            disabled={isDisabled}
            value={value}
            onChange={(e) => {
              setSelectedValue(e?.target?.value);
              registration.onChange(e);
              if (onChange) onChange(e);
            }}

          style={{
            color: !selectedValue ? "gray" : "black",
          }}
             
          >
          <option value="">Select {label}</option>
            {options.map((opt, index) => (
              <option key={index} value={opt?.name}>
                {opt?.name}
              </option>
          ))}
          </select>
        </div>
      </div>
    );
  };
  
  export default CommonSelect;